import posthog, { PostHogConfig } from 'posthog-js';
import { COOKIE_CONSENT_KEY, getCookie, setCookie } from '../helpers/cookies';

const disableReplay = localStorage.getItem('no_replay') === 'true';

export const POSTHOG_KEY = import.meta.env.VITE_PUBLIC_POSTHOG_KEY as string;

const POSTHOG_HOST = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;

// Base configuration object
const baseConfig: Partial<PostHogConfig> = {
  api_host: POSTHOG_HOST,
  session_recording: {
    maskAllInputs: false,
  },
  disable_session_recording: disableReplay,
  autocapture: true,
  capture_pageview: true,
};

const posthogFullTrackingConfig: Partial<PostHogConfig> = {
  ...baseConfig,
  disable_persistence: false,
  persistence: 'localStorage+cookie',
};

const posthogMemoryOnlyConfig: Partial<PostHogConfig> = {
  ...baseConfig,
  disable_persistence: true,
  persistence: 'memory',
  disable_session_recording: true,
  autocapture: false,
};

export const getInitialPostHogConfig = (): Partial<PostHogConfig> => {
  const consent = getCookie(COOKIE_CONSENT_KEY);
  return consent === 'accepted'
    ? posthogFullTrackingConfig
    : posthogMemoryOnlyConfig;
};

export const enableAnalytics = () => {
  setCookie(COOKIE_CONSENT_KEY, 'accepted');
  posthog.reset();
  posthog.set_config(posthogFullTrackingConfig);
};

export const disableAnalytics = () => {
  setCookie(COOKIE_CONSENT_KEY, 'rejected');
  posthog.reset();
  posthog.set_config(posthogMemoryOnlyConfig);
};
